import { Usuario } from "../../components/usuario/Usuario";

export const UsuarioPage = () => {
    return (
        <div>
            <Usuario />
        </div>
    );
};
